import React from 'react';
import { IAttendeeInput, IControlAttendeeDetailsDTO, IFilteredOrganization } from '../../../../../api/attendees.dao';
import './attendees-section.scss';
import { Organization } from './_organization';
import { Attendee } from './_attendee/_attendee';
import { RUN_MEETING_EVENTS } from '../../../../../tracking-service/tracking-values';
import * as mobxReact from 'mobx-react';


interface IAttendeesListProps {
    onChangeAttendee: (attendeeInput: IAttendeeInput, roleKey: string, organizationId: number, attendeeId: number) => void;
    fetchAttendeeData: (attendeeId: number) => Promise<IControlAttendeeDetailsDTO>;
    eventTimezone: string;
    withTableView?: boolean;
    roleKey: string;
    removeWalkIn: (organizationId: number, attendeeId: number) => void;
    attendeeIdToConnectionNameMap?: { [id: string] : string };
    orgIdToConnectionParticipantsNameMap?: { [id: string] : string };
    orgIdToConnectionPresentersNameMap?: {[id: string] : string };
    orgIdToConnectionHostsNameMap?: {[id: string] : string };
    orgIdToConnectionSupportsNameMap?: {[id: string] : string };
    onEditAttendee: (attendeeId: number) => void;
    selectedAttendeeFilter?: boolean;
    isAttendeeListSortedByFirstName?: boolean;
    isMeetingUnderway: boolean;
    handleTrackingEvent?: (event: RUN_MEETING_EVENTS, value?: string) => void;
}

interface IProps extends IAttendeesListProps {
    organizations: IFilteredOrganization[];
}

const AttendeesList = mobxReact.observer((props: IProps) => {
    const { organizations, selectedAttendeeFilter, ...otherProps } = props;
    const attendeesAccumulator = [];
    organizations
        .slice()
        .forEach(organization => {
            const attendeesArray = organization.attendees;
            attendeesArray.forEach(attendee => {
                attendeesAccumulator.push({
                    organizationId: organization.organizationId,
                    organizationName: organization.name,
                    markedOrganization: organization.markedOrganization,
                    ...attendee});
            });
        });

    return (
        <div className='attendees-list'>
            {!selectedAttendeeFilter ?
                organizations
                    .slice()
                    .sort((a, b) => a.name.localeCompare(b.name))
                    .map(organization => {
                        return <Organization
                            key={organization.organizationId}
                            {...organization}
                            {...otherProps}
                        />;
                    }) : attendeesAccumulator
                    .slice()
                    .sort((a, b) => a.firstName.localeCompare(b.firstName))
                    .map(attendee => <Attendee
                        key={attendee.attendeeId}
                        organizationId={attendee.organizationId}
                        selectedAttendeeFilter={selectedAttendeeFilter}
                        organizationName={attendee.organizationName}
                        markedOrganization={attendee.markedOrganization}
                        {...attendee}
                        {...otherProps}
                    />)
            }
        </div>
    );
});

export { AttendeesList, IAttendeesListProps };
